// src/components/BlogPreviewList.jsx
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { loadArticles } from "../data/loadArticles";

export default function BlogPreviewList() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    loadArticles().then((articles) => {
      setPosts(articles.slice(0, 4)); // 3 aktuelle Beiträge
    });
  }, []);

  // Titel kürzen bei Bedarf
  const truncateTitle = (text, maxLength = 20) => {
    if (!text) return "";
    if (text.length <= maxLength) return text;
    const truncated = text.substr(0, maxLength);
    return truncated.substr(0, truncated.lastIndexOf(" ")) + " …";
  };

  return (
    <ul className=" space-y-2">
      {posts.map((post) => (
        <li key={post.slug}>
          <Link
            to={`/post/${post.slug}`}
            className="block leading-snug text-gray-700 hover:text-black transition-colors hover:underline"
          >
            {truncateTitle(post.title, 20)}
          </Link>
        </li>
      ))}
    </ul>
  );
}
